import { GetMeResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export const getMe = makeCloudFunction<void, GetMeResponse>("me", "getMe");
